var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"p-2 border-top text-danger cursor-pointer"},[_c('feather-icon',{attrs:{"icon":"LogOutIcon"}}),_c('span',{staticClass:"ml-1"},[_vm._v("Logout")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }